define('viewmodels/modals/dialogs/ReelRacesHowItWorksDialog',[
   'knockout',
   'underscore'
], function () {

    var ReelRacesHowItWorksDialog = function (dialog, generalPage, session, options) {
        var self = this,
            specificPage = generalPage.getChildBySlug('guns-n-roses');

        self.options = {
            mode: 'default'
        };

        self.instructionsText = generalPage.findFieldByName('instructions_text');
        self.instructionsReadMoreButtonText = generalPage.findFieldByName('instructions_read_more_button');
        self.instructionsBackgroundImageUrl = specificPage.findFieldByName('instructions_background');

        self.rulesTitle = specificPage.findFieldByName('rules_title');
        self.rules = specificPage.findFieldByName('rules_content').withFallback([]);

        self.howItWorksTitle = specificPage.findFieldByName('how_it_works_title');
        self.howItWorks = specificPage.findFieldByName('how_it_works_content').withFallback([]);

        self.pointsInfoTitle = specificPage.findFieldByName('points_info_title');
        self.pointsInfo = specificPage.findFieldByName('points_info_content').withFallback([]);

        self.termsText = specificPage.findFieldByName('terms_text');

        self.recommendedGamesTitle = generalPage.findFieldByName('recommended_games_title');
        self.goToScheduleText = generalPage.findFieldByName('go_to_schedule_text');

        self.recommendedGames = specificPage.findFieldByName('recommended_games').withFallback([]);

        self.dialog = dialog;

        self.loggedIn = session.loggedIn();

        if (options) {
            self.options = options;
        }
    };

    ReelRacesHowItWorksDialog.prototype.close = function () {
        this.dialog.close(this);
    };

    return ReelRacesHowItWorksDialog;
});

